import { Lightning, Router } from "@lightningjs/sdk";
import { Card } from "./Card";
import { FOCUS_TRANSITION } from "./focus";
export class SquareCard extends Lightning.Component {
    constructor() {
        super(...arguments);
        this._href = "";
        this._description = "";
    }
    static _template() {
        return {
            h: this.H,
            w: this.W,
            PosterContainer: {
                h: this.H,
                w: this.W,
                clipping: true,
                renderToTexture: true,
                color: 0x00000000,
                rect: true,
                shader: {
                    type: Lightning.shaders.RoundedRectangle,
                    radius: this.BORDER_R,
                },
                Poster: {
                    h: this.H,
                    w: this.W,
                    texture: { type: Lightning.textures.ImageTexture },
                },
                Logo: { x: 61, y: 61, w: 200, h: 200, visible: false },
                Border: {
                    alpha: 0,
                    color: Card.BORDER_COLOR,
                    texture: Card.borderTexture(this.W, this.H, this.BORDER_R),
                },
            },
        };
    }
    static get width() {
        return this.W;
    }
    static get height() {
        return this.H;
    }
    static get marginRight() {
        return Card.marginRight;
    }
    set description(description) {
        this._description = description;
    }
    set posterSrc(posterSrc) {
        this.tag("PosterContainer.Poster").patch({ src: posterSrc });
    }
    set posterCrop(posterCrop) {
        this.tag("PosterContainer").patch({
            Poster: { texture: posterCrop !== null && posterCrop !== void 0 ? posterCrop : { x: 0, y: 0, w: 0, h: 0 } },
        });
    }
    set logoSrc(logoSrc) {
        this.tag("PosterContainer.Logo").patch({
            src: logoSrc,
            visible: !!logoSrc,
        });
    }
    set href(href) {
        this._href = href !== null && href !== void 0 ? href : "";
    }
    _focus() {
        this.tag("PosterContainer.Border").setSmooth("alpha", 1, FOCUS_TRANSITION);
    }
    _unfocus() {
        this.tag("PosterContainer.Border").setSmooth("alpha", 0, FOCUS_TRANSITION);
    }
    _handleEnter() {
        if (this._href)
            Router.navigate("video", {
                href: this._href,
                title: this._description,
                category: this.fireAncestors("$getPlaybackCategory") || "Clubs",
            });
    }
}
SquareCard.W = Card.W;
SquareCard.H = SquareCard.W;
SquareCard.BORDER_R = 16.544;
export default SquareCard;
//# sourceMappingURL=SquareCard.js.map